import { FilesHelpers } from 'helpers/files';
import { BlobWrapper } from 'interfaces/blobWrapper';
import WCCVideo from 'models/attachments/video';
import WCCUpload from 'models/upload';
import UserFile from 'models/userFile';
import WCCUploader from '../uploader';
import WCCS3ImageUploader from './image';
import transportFactory from './transportFactory';
import { WCCS3UploadResult } from './uploadResult';

const { allowedUploadVideoExtensions } = settings;

export interface WCCS3VideoUploaderConfig {
    key?: string
}

export default class WCCS3VideoUploader extends WCCUploader<WCCVideo, WCCS3UploadResult> {
    private previewUploader: WCCS3ImageUploader

    constructor(config?: WCCS3VideoUploaderConfig) {
        super({
            transport: transportFactory.getTransport({
                type: 'video',
                key: config?.key
            }),

            allowedExtensions: allowedUploadVideoExtensions,
        });

        this.previewUploader = new WCCS3ImageUploader();
    }

    protected override async getUpload(fileOrBlob: File | BlobWrapper) {
        try {
            const upload = new WCCUpload({ name: fileOrBlob.name });

            FilesHelpers.getPreview(fileOrBlob).then(preview => {
                upload.width(preview.width);
                upload.height(preview.height);
                upload.preview(preview.src);
            });

            return upload;
        } catch (ex) {
            return new WCCUpload({ name: fileOrBlob.name });
        }
    }

    protected async getResult(uploadResult: WCCS3UploadResult, upload: WCCUpload, fileOrBlob: File | BlobWrapper) {
        let previewFile: UserFile | undefined;

        try {
            const preview = await FilesHelpers.getPreview(fileOrBlob);
            previewFile = await this.uploadPreview(fileOrBlob.name.toLowerCase(), preview.src);
        } catch (ex) {}

        const video = new WCCVideo({
            FileType: enums.AttachmentTypes.Video.value,
            CreateDate: new Date().toISOString(),

            Files: [
                {
                    UserFileId: uploadResult.fileId,
                    Name: fileOrBlob.name,
                    Extension: system.getExtension(fileOrBlob.name),
                    Link: uploadResult.link,
                    Width: upload.width(),
                    Height: upload.height(),
                    Type: enums.UserFileTypes.OriginalVideo.value,
                    CreateDate: new Date().toISOString()
                }
            ]
        });

        if (previewFile != undefined)
            video.files.push(previewFile);

        return video;
    }

    private async uploadPreview(videoName: string, content: string) {
        try {
            const ext = system.getExtension(videoName);

            if (ext == undefined)
                throw new Error('invalid extension');

            const name = videoName.replace(ext, 'jpg');

            const blob = FilesHelpers.base64toBlob(content);
            const blobWrapper = <BlobWrapper>{ blob, name };

            const attachment = await this.previewUploader.upload(blobWrapper);
            const file = attachment.files().find(f => f.type() == enums.UserFileTypes.OriginalImage.value);

            if (file == undefined)
                throw new Error('preview upload failed');

            file.type(enums.UserFileTypes.VideoThumbnail.value);
            return file;
        } catch (ex) {
            console.warn(`video ${videoName} preview generation failed`, ex);
            return undefined;
        }
    }
}